<template>
  <aside class="embedded-nav d-none d-lg-block">
    <div class="sticky-top d-flex flex-column" style="height: 100vh">
      <NuxtImg v-if="!!affiliateCustomizations && !iframeHeaderVisible && !!appNavLogo"
           :src="formatImagePath(appNavLogo)"
           alt=""
           class="affiliate-customizations-app-nav-logo"/>
      <nav class="px-8 py-6">
        <slot />
      </nav>
      <div class="d-none d-lg-block mt-auto">
        <EmbeddedSupportInfo v-if="contactInfoEnabled" />
        <PoweredByLendio v-if="poweredByLendioEnabled" />
      </div>
    </div>
  </aside>
</template>

<script>
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import EmbeddedSupportInfo from './EmbeddedSupportInfo.vue'
import PoweredByLendio from '~/components/PoweredByLendio.vue'
import { mapState } from 'pinia'
import formatImagePath from '~/libs/image-format'

export default {
  name: 'EmbeddedNavContainer',
  components: {
    EmbeddedSupportInfo,
    PoweredByLendio
  },
  setup() {
    return { formatImagePath }
  },
  data() {
    return {
      sidenavToggle: false,
      linkHover: '',
    }
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'affiliateCustomizations',
      'contactInfoEnabled',
      'appNavLogo',
      'poweredByLendioEnabled',
      'iframeHeaderVisible'
    ]),
  },
}
</script>

<style lang="scss">
@import 'assets/styles/affiliate-customizations/affiliate-customization-mixins';

$app-aside-background-color: var(--app-aside-background-color);

.embedded-nav {
  z-index: 100;
  height: 100%;
  background-color: $app-aside-background-color;
  border-right: 1px solid #DCDBDB;
}

.affiliate-customizations-app-nav-logo {
  @include affiliateAppNavLogoPortal();
}

</style>
